// extracted by mini-css-extract-plugin
export default {"container":"CardOfAspect_container__LmCeT","icon":"CardOfAspect_icon__3oNFv"};